import app from '../app.jsx'

class ConnectionUtil {
  initSocketConnectionEvents (reconnectCallback) {
    // Check the connection for the first time once
    this.checkConnection(reconnectCallback, false)

    // Init events
    this._initDisconnectEvent(reconnectCallback)
  }

  releaseSocketConnectionEvents () {
    this._releaseDisconnectEvent()
    this._releaseReconnectEvent()
  }

  checkConnection (reconnectCallback, bShowMessage) {
    // If socket disconnected
    app.socket.io.connect((err) => {
      if (!err) {
        this._releaseReconnectEvent()

        if (reconnectCallback) {
          reconnectCallback(true, bShowMessage)
        }
      } else {
        this._initReconnectEvent(reconnectCallback)

        if (reconnectCallback) {
          reconnectCallback(false, bShowMessage)
        }
      }
    })
  }

  /* Private functions */
  _onSockeDisconnected (reconnectCallback) {
    setTimeout(() => {
      this.checkConnection(reconnectCallback, false)
    }, 5000)
  }

  _onSockeReconnected (reconnectCallback) {
    this._releaseReconnectEvent()
    if (reconnectCallback) {
      reconnectCallback(true, true)
    }
  }

  _initDisconnectEvent (reconnectCallback) {
    this._socketDisconnected = this._onSockeDisconnected.bind(
      this,
      reconnectCallback
    )
    app.socket.on('disconnect', this._socketDisconnected)
  }

  _initReconnectEvent (reconnectCallback) {
    if (this._reconnectTime) window.clearTimeout(this._reconnectTime)

    // Check connection every 5 seconds
    this._reconnectTime = window.setTimeout(() => {
      this.checkConnection((bConnected) => {
        if (bConnected) {
          reconnectCallback(true, true)
        } else {
          this._initReconnectEvent(reconnectCallback)
        }
      }, true)
    }, 5000)
  }

  _releaseDisconnectEvent () {
    if (this._socketDisconnected) {
      app.socket.off('disconnect', this._socketDisconnected)
    }
  }

  _releaseReconnectEvent () {
    if (this._reconnectTime) window.clearTimeout(this._reconnectTime)
  }
}

export default new ConnectionUtil()
